/**
 * Temporary allowlist of offer IDs for which the new canUpgradePackage flag
 * from svc-order is used for self-service package upgrades.
 * This restricts the rollout to only these properties while we validate the flow.
 * For non-allowlisted offers, the pre-existing canAutoRefund / canRefundItem logic applies.
 * TODO: Remove this allowlist once canUpgradePackage is validated for all offers.
 */
export const PACKAGE_UPGRADE_ALLOWED_OFFER_IDS = new Set([
  '006RF00000ONXqHYAX', // Merusaka Nusa Dua
  '006RF00000OqAVJYA3', // Katathani Phuket Beach Resort
  '006RF00000Tyg0YYAR', // Dhigufaru Island Resort
  '006RF00000SQWKHYA5', // Centara Mirage Lagoon Maldives
  '006RF00000OnBB4YAN', // Seaside Finolhu Baa Atoll Maldives
  '006RF00000OqYXeYAN', // Ifuru Island
  '006RF00000OjiFCYAZ', // Hard Rock Hotel Maldives
  '006RF00000TzCzdYAF', // SAii Lagoon Maldives, Curio Collection by Hilton
  '006RF00000RcJTVYA3', // SO/ Maldives
  '006RF00000Ol82jYAB', // Centara Grand Lagoon Maldives
  '006RF00000NdIj9YAF', // Mercure Maldives Kooddoo
  '006RF00000OXJu5YAH', // Outrigger Maldives Maafushivaru Resort
  '006RF00000NuworYAB', // Park Hyatt Maldives Hadahaa
  '006RF00000Tl5ErYAJ', // NH Maldives Kuda Rah Resort
  '006RF00000NVMgXYAX', // Lily Beach Resort and Spa
  '006RF00000P1WAtYAN', // The Halcyon Private Isles Maldives, Autograph Collection
  '006RF00000OWmq8YAD', // Avani+ Fares Maldives Resort
  '006RF00000NZkFfYAL', // Pullman Maldives Maamutaa
])
